<template>
  <!--  金融-->
  <div class="waiceng">
    <el-menu
        :default-active="dictDataType"
        class="el-menu-vertical-demo"
        :unique-opened="true"
        @select="selectChange">
      <el-submenu index="财政">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">财政</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_finance_income">公共财政收入:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_finance_difference">财政收支差额:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_finance_center">中央财政收入:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_finance_local">地方本级财政收入:当月值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="货币市场">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">货币市场</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_m1">M1</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_m2">M2</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_m1_same">M1:同比</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_m2_same">M2:同比</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="金融市场">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">金融市场</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_rate">银行间同业拆借:加权平均利率:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_bond">债券市场发行债券</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_bond_country">债券市场发行债券:国债</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_bond_local">债券市场发行债券:地方政府债券</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_loan">社会融资规模:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_loan_cny">社会融资规模:新增人民币贷款:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_market_loan_other">社会融资规模:新增外币贷款:当月值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="汇率">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">汇率</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_cny_usd">中间价:美元兑人民币</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <Detail class="detail" :dictDataType="dictDataType"></Detail>
  </div>
</template>

<script>
import Detail from '@/components/macroscopic/detail'

export default {
  name: "economics",
  components: {
    Detail
  },
  data() {
    return {
      dictDataType: 'issue_macroscopic_finance_income',
    }
  },
  created() {
  },
  methods: {
    /**
     * 切换详情
     * @param index
     */
    selectChange(index) {
      this.dictDataType = index;
    }
  },
}
</script>

<style scoped lang="less">
.detail {

}

.el-menu {
  color: #222222;
  display: inline-block;
  vertical-align: top;
  width: 236px;
  min-height: 688px;
  box-shadow: 0px 2px 10px 0px rgb(183 183 183 / 50%);
}

.redIcon {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #D3131A;
  border-radius: 1px;
  font-style: normal;
  margin-right: 15px;
  vertical-align: middle;
}

.write {
  font-style: normal;
  vertical-align: middle;
  display: inline-block
}
</style>
